import { axiosHttpClient } from "../axios";
import handleStatusCases from "../handle-status-cases";

const { REACT_APP_BASE_URL } = process.env;

type TCreateProjectComment = {
    projectId: string;
    commentId: string;
    params: {
        text: string;
    };
};

export default async ({
    projectId,
    commentId,
    params,
}: TCreateProjectComment) => {
    const tempHeaders = {
        auth: true,
    };

    const httpRequest = await axiosHttpClient({
        url: `${REACT_APP_BASE_URL}/project/${projectId}/comment/${commentId}`,
        method: "patch",
        body: params,
        headers: tempHeaders,
    });
    const { body, statusCode } = httpRequest;

    return handleStatusCases({ body, statusCode });
};
